import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



interface IProps {
  vertical?: boolean;
  halfGap?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListRowWrap',
  props: {
    vertical: { type: Boolean },
    halfGap: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-row", { vertical: _ctx.vertical, 'half-gap': _ctx.halfGap }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})